@if (logs$ | async; as logs) {
  <div class="log-viewer-container">
<pre #logViewer>
<code>@for (log of logs; track log) {<span [class]="'tp-server-index tp-server-' + log.serverIndex" [matTooltip]="'Server ' + log.serverIndex"></span><span>{{ log.line }}</span>
}
</code>
</pre>
  </div>
} @else {
  <tp-spinner/>
}
